<template>
  <button
    v-if="showNext"
    type="button"
    class="min-w-full text-vp-base-100 bg-primary focus:outline-none active:outline-none focus:scale-y-98 focus:scale-x-95 py-2 px-4 rounded-lg font-semibold text-sm"
    :disabled="lockButtonDisabled"
    size="lg"
    @click="emit('next')"
  >
    {{ label }}
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useCheckoutStore } from './stores/checkout';
import { useGettext } from 'vue3-gettext';
import { Util } from '@vp/common';

const { LoadingState } = Util;

const checkoutStore = useCheckoutStore();

const { $gettext } = useGettext();

const emit = defineEmits<{
  (e: 'next'): void;
}>();

type Props = {
  showNext: boolean;
  disableNext?: boolean;
  nextLabel?: string;
};

const props = defineProps<Props>();

const label = computed(() => props.nextLabel ?? $gettext('Next'));

const lockButtonDisabled = computed(
  () =>
    props.disableNext ||
    checkoutStore.shoppingCartLockLoading == LoadingState.LOADING ||
    checkoutStore.holdsSettling,
);
</script>
